import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { FamilyHistoryProvider } from "./FamilyHistoryContext";
import { EthnicityScreen } from "./screens/EthnicityScreen";
import { DnaTestScreen } from "./screens/DnaTestScreen";
import { DnaTestReportScreen } from "./screens/DnaTestReportScreen";
import { AdoptedScreen } from "./screens/AdoptedScreen";
import { FamilyInfertilityScreen } from "./screens/FamilyInfertilityScreen";
import { FamilyMemberScreen } from "./screens/FamilyMemberScreen";
import { DesScreen } from "./screens/DesScreen";
import { MaternalDiseasesScreen } from "./screens/MaternalDiseasesScreen";
import { PaternalDiseasesScreen } from "./screens/PaternalDiseasesScreen";
import { FamilyHistoryCompleteScreen } from "./screens/FamilyHistoryCompleteScreen";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type FamilyHistoryStackParamList = {
  Ethnicity: undefined;
  DnaTest: undefined;
  DnaTestReport: undefined;
  Adopted: undefined;
  FamilyInfertility: undefined;
  FamilyMember: undefined;
  Des: undefined;
  MaternalDiseases: undefined;
  PaternalDiseases: undefined;
  FamilyHistoryComplete: undefined;
};

export type FamilyHistoryStackScreenProps<
  T extends keyof FamilyHistoryStackParamList,
> = StackScreenProps<FamilyHistoryStackParamList, T>;

const Stack = createNativeStackNavigator<FamilyHistoryStackParamList>();

export function FamilyHistoryNavigator() {
  return (
    <FamilyHistoryProvider>
      <MedicalHistoryQuestionProvider
        section="family-history"
        sectionLabelKey="med_history.review.section_title.family-history"
        helpTextKey="med_history.question_screen.flow_help.family-history"
      >
        <Stack.Navigator
          initialRouteName="Ethnicity"
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen name="Ethnicity" component={EthnicityScreen} />
          <Stack.Screen name="DnaTest" component={DnaTestScreen} />
          <Stack.Screen name="DnaTestReport" component={DnaTestReportScreen} />
          <Stack.Screen name="Adopted" component={AdoptedScreen} />
          <Stack.Screen
            name="FamilyInfertility"
            component={FamilyInfertilityScreen}
          />
          <Stack.Screen name="FamilyMember" component={FamilyMemberScreen} />
          <Stack.Screen name="Des" component={DesScreen} />
          <Stack.Screen
            name="MaternalDiseases"
            component={MaternalDiseasesScreen}
          />
          <Stack.Screen
            name="PaternalDiseases"
            component={PaternalDiseasesScreen}
          />
          <Stack.Screen
            name="FamilyHistoryComplete"
            component={FamilyHistoryCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </FamilyHistoryProvider>
  );
}
